<div class="chart-container">
  <div class="chart-container-header">
    <h4>Sales Timeline by SKU</h4>
    <div class="subtitle">
      <p>*visible when SKU is clicked. Target Period Filter is not applied to this chart. </p>
    </div>
  </div>

  <div class="progress-timeline-container">
    <div class="charts-wrapper">
      <!-- Value Chart -->
      <div class="chart-section">
        <div class="chart-title">
          <p>Val.</p>
        </div>
        <div class="chart-item">
          <div #valueChart class="chart-overlay"></div>
        </div>
      </div>

      <!-- Coverage Chart -->
      <div class="chart-section">
        <div class="chart-title">
          <p>Coverage</p>
        </div>
        <div class="chart-item">
          <div #coverageChart class="chart-overlay"></div>
        </div>
      </div>

      <!-- Turn Chart -->
      <div class="chart-section">
        <div class="chart-title">
          <p>Turn (Bottle)</p>
        </div>
        <div class="chart-item">
          <div #turnChart class="chart-overlay"></div>
        </div>
      </div>

      <!-- Price Chart -->
      <div class="chart-section">
        <div class="chart-title">
          <p>Price (Bottle)</p>
        </div>
        <div class="chart-item">
          <div #priceChart class="chart-overlay"></div>
        </div>
      </div>

      <!-- <div class="chart-section-date">
        <div class="chart-title">
          <p >&nbsp;</p>
        </div>
     
        <div class="chart-item-date">
          <div style="width: 60px;"></div>
          <div class="chart-item" *ngFor="let item of valueDateChartData">
            <p>{{ item }}</p>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</div>

<div class="d-flex flex-row-reverse mt-4 hide-pdf-print">
  <download-button >
    <a #downloadLink style="display: none;"></a>
    <button  ngbDropdownItem (click)="onDownloadDetail()">Download
      CSV</button>
  </download-button>
</div>
